import React, { useEffect, useState } from 'react'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import { Grid, TextField } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import BackArrow from '../../assets/img/back-arrow.png'

import {
  isEmpty,
  isEmptyLastName,
  isEmailValid,
  isEmailValidGifted,
  isEmptyGifted,
  isEmptyLastNameGifted,
} from '../../utils/helpers'

import {
  makeSelectName,
  makeSelectLastName,
  makeSelectPhone,
  makeSelectEmail,
  makeSelectGiftedName,
  makeSelectGiftedLastName,
  makeSelectGiftedPhone,
  makeSelectGiftedEmail,
  set_name,
  set_last_name,
  set_phone,
  set_email,
  set_gifted_name,
  set_gifted_last_name,
  set_gifted_phone,
  set_gifted_email,
} from '../../redux/ducks/reservationInfo'

import {
  makeSelectGiftCard,
  set_guest_amount,
  set_is_gift_card,
} from '../../redux/ducks/reservationDetails'
import { Box } from '@mui/material'
import { Col, Row, Button, Layout, Space, Form, Input } from 'antd'

const stateSelector = createSelector(
  [
    makeSelectName,
    makeSelectLastName,
    makeSelectPhone,
    makeSelectEmail,
    makeSelectGiftCard,
    makeSelectGiftedName,
    makeSelectGiftedLastName,
    makeSelectGiftedPhone,
    makeSelectGiftedEmail,
  ],
  (
    name,
    lastName,
    phone,
    email,
    giftCard,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
  ) => ({
    name,
    lastName,
    phone,
    email,
    giftCard,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
  }),
)

const actionDispatch = (dispatch) => ({
  setName: (name) => dispatch(set_name(name)),
  setLastName: (lastName) => dispatch(set_last_name(lastName)),
  setPhone: (phone) => dispatch(set_phone(phone)),
  setEmail: (email) => dispatch(set_email(email)),
  setGiftedName: (giftedName) => dispatch(set_gifted_name(giftedName)),
  setGiftedLastName: (giftedLastName) =>
    dispatch(set_gifted_last_name(giftedLastName)),
  setGiftedPhone: (giftedPhone) => dispatch(set_gifted_phone(giftedPhone)),
  setGiftedEmail: (giftedEmail) => dispatch(set_gifted_email(giftedEmail)),
  setIsGiftCard: (giftCard) => dispatch(set_is_gift_card(giftCard)),
})

const PersonalInfo = ({ handleBack, handleNext, type, hotDeal,
  isErrorName, isErrorLastName, isErrorEmail,isValidPhone, isErrorGiftedName, isErrorGiftedLastName, isErrorGiftedEmail,isValidGiftedPhone,
  setIsErrorName, setIsErrorLastName, setIsErrorEmail,setIsValidPhone ,setIsErrorGiftedName, setIsErrorGiftedLastName, setIsErrorGiftedEmail, setIsValidGiftedPhone }) => {
  const {
    name,
    lastName,
    phone,
    email,
    giftCard,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
  } = useSelector(stateSelector)
  const {
    setName,
    setLastName,
    setPhone,
    setEmail,
    setGiftedName,
    setGiftedLastName,
    setGiftedPhone,
    setGiftedEmail,
  } = actionDispatch(useDispatch())



  useEffect(() => {
    if (
      hotDeal === undefined ||
      hotDeal === null ||
      Object.keys(hotDeal).length === 0 ||
      Object.keys(hotDeal).length === null ||
      Object.keys(hotDeal).length === undefined
    ) {
      return null
    } else if (hotDeal && hotDeal.giftCard.isGiftCard) {
      setName(hotDeal.name)
      setLastName(hotDeal.lastName)
      setPhone(hotDeal.phone)
      setEmail(hotDeal.email)
      setGiftedName(hotDeal.giftCard.giftedName)
      setGiftedLastName(hotDeal.giftCard.giftedLastName)
      setGiftedPhone(hotDeal.giftCard.giftedPhone)
      setGiftedEmail(hotDeal.giftCard.giftedEmail)
    } else if (hotDeal) {
      setName(hotDeal.name)
      setLastName(hotDeal.lastName)
      setPhone(hotDeal.phone)
      setEmail(hotDeal.email)
    }
    if (Object.keys(hotDeal).length === 0) {
      return null
    } else if (hotDeal && hotDeal.giftCard.isGiftCard) {
      setName(hotDeal.name)
      setLastName(hotDeal.lastName)
      setPhone(hotDeal.phone)
      setEmail(hotDeal.email)
      setGiftedName(hotDeal.giftCard.giftedName)
      setGiftedLastName(hotDeal.giftCard.giftedLastName)
      setGiftedPhone(hotDeal.giftCard.giftedPhone)
      setGiftedEmail(hotDeal.giftCard.giftedEmail)
    } else if (hotDeal) {
      setName(hotDeal.name)
      setLastName(hotDeal.lastName)
      setPhone(hotDeal.phone)
      setEmail(hotDeal.email)
    }
  }, [])

  const validateName = (inputValue) => {
    const isValidName = isEmpty(inputValue)
    setIsErrorName(!isValidName)
    return isValidName
  }

  const validateLastName = (inputValue) => {
    const isEmptyLastN = isEmptyLastName(inputValue)
    setIsErrorLastName(!isEmptyLastN)
    return isEmptyLastN
  }

  const validatePhone = (inputValue) => {
    const isValidPhone = inputValue.length >= 11
    setIsValidPhone(isValidPhone)
    return isValidPhone
  }

  const validateEmail = (inputValue) => {
    const isValidEmail = isEmailValid(inputValue)
    setIsErrorEmail(!isValidEmail)
    return isValidEmail
  }

  const validateGiftedName = (inputValue) => {
    const isEmptyGiftedName = isEmptyGifted(inputValue)
    setIsErrorGiftedName(!isEmptyGiftedName)
    return isEmptyGiftedName
  }

  const validateGiftedLastName = (inputValue) => {
    const isEmptyGiftedLastName = isEmptyLastNameGifted(inputValue)
    setIsErrorGiftedLastName(!isEmptyGiftedLastName)
    return isEmptyGiftedLastName
  }

  const validateGiftedPhone = (inputValue) => {
    const isValidGiftedPhone = inputValue.length >= 11
    setIsValidGiftedPhone(isValidGiftedPhone)
    return isValidGiftedPhone
  }

  const validateGiftedEmail = (inputValue) => {
    const isGiftedEmailValid = isEmailValidGifted(inputValue)
    setIsErrorGiftedEmail(!isGiftedEmailValid)
    return isGiftedEmailValid
  }

  // const validateForm = () => {
  //   const boolName = validateName()
  //   const boolLasName = validateLastName()
  //   const boolPhone = validatePhone()
  //   const boolEmail = validateEmail()

  //   const boolGiftedName = validateGiftedName()
  //   const boolGiftedLasName = validateGiftedLastName()
  //   const boolGiftedPhone = validateGiftedPhone()
  //   const boolGiftedEmail = validateGiftedEmail()

  //   if (giftCard) {
  //     if (
  //       boolName &&
  //       boolLasName &&
  //       boolPhone &&
  //       boolEmail &&
  //       boolGiftedName &&
  //       boolGiftedLasName &&
  //       boolGiftedPhone &&
  //       boolGiftedEmail
  //     ) {
  //       //no se ejecutaran acciones //prueba sin button
  //     }
  //   } else {
  //     if (boolName && boolLasName && boolPhone && boolEmail) {
  //       //no se ejecutaran acciones //prueba sin button
  //     }
  //   }
  // }

  // const handleKeyPress = (e) => {
  //   if (e.key === 'Enter') {
  //     validateForm()
  //   }
  // }

  return (
    <div
      className="container-checkout"
      // style={{
      //   display: 'flex',
      //   flexWrap: 'wrap',
      //   boxSizing: 'border-box',
      //   marginTop: '12px',
      // }}
      // className="spacer"
    >
      <Row gutter={16}>
        <Col span={24}>
          <img
            src={BackArrow}
            alt="img not found"
            onClick={handleBack}
            width={40}
          />
        </Col>
      </Row>
      <div style={{ textAlign: 'center' }} className="datacomp">
        <span style={{ fontWeight: 'bold', margin: 'auto' }}>
          Datos del Comprador/a{' '}
        </span>
      </div>
      <Row
        gutter={16}
        className="grid-data-gift"
        style={{ width: '100% !important' }}
      >
        <Col span={window.innerWidth >= 992 ? 8 : 24} className="data-gift ">
          <Input
            onError={isErrorName ? 'error' : null}
            placeholder="Nombre"
            required
            value={name}
            onChange={(e) => {
              setName(e.target.value)
              validateName(e.target.value)
            }}
            style={isErrorName ? { borderColor: 'red' } : {}}
            size="middle"
            className="inputnumber"
          />
        </Col>
        <Col span={window.innerWidth >= 992 ? 8 : 24} className="label-hr-gift">
          <Input
            // onKeyUp={handleKeyPress}

            onError={isErrorLastName ? 'error' : null}
            size="middle"
            placeholder="Apellido"
            variant="outlined"
            required
            value={lastName}
            onChange={(e) => {
              setLastName(e.target.value)
              validateLastName(e.target.value)
            }}
            style={isErrorLastName ? { borderColor: 'red' } : {}}
            className="inputnumber"
          />
        </Col>
        <Col span={window.innerWidth >= 992 ? 8 : 24} className="data-gift">
          <PhoneInput
            inputStyle={{
              width: '100%',
              height: '2vh',
            }}
            className="phoneInp"
            // onKeyUp={handleKeyPress}
            isValid={isValidPhone}
            country="cl"
            preferredCountries={['cl', 'br', 'us']}
            value={phone}
            onChange={(value, country, e, formattedValue) => {
              if (value.length >= 11) {
                setPhone(value)
                validatePhone(e.target.value)
              } else {
                return null
              }
            }}
            masks={{ cl: '(..) ... ....' }}
            autoFormat
            specialLabel=""
          />
        </Col>

        <Col span={window.innerWidth >= 992 ? 8 : 24} className="label-hr-gift">
          <Input
            size="middle"
            // onKeyUp={handleKeyPress}
            error={isErrorEmail ? 'error' : null}
            placeholder="Correo eletrónico"
            variant="outlined"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)

              validateEmail(e.target.value)
            }}
            style={isErrorEmail ? { borderColor: 'red' } : {}}
            className="inputnumber"
          />
        </Col>
      </Row>

      {giftCard && (
        <>
          <br />
          <div style={{ textAlign: 'center' }} className="datacomp">
            <span style={{ fontWeight: 'bold', margin: 'auto' }}>
              Datos del Obsequiado{' '}
            </span>
          </div>
          <Row
            gutter={16}
            className="grid-data-gift"
            style={{ width: '100% important' }}
          >
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="data-gift "
            >
              <Input
                // onKeyUp={handleKeyPress}
                error={isErrorGiftedName ? 'error' : null}
                placeholder="Nombre Obsequiado"
                required
                value={giftedName}
                onChange={(e) => {
                  setGiftedName(e.target.value)
                  validateGiftedName(e.target.value)
                }}
                style={isErrorGiftedName ? { borderColor: 'red' } : {}}
                className="inputnumber"
                size="middle"
              />
            </Col>
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="label-hr-gift"
            >
              <Input
                // onKeyUp={handleKeyPress}
                error={isErrorGiftedLastName ? 'error' : null}
                className="inputnumber"
                size="middle"
                placeholder="Apellido"
                variant="outlined"
                required
                value={giftedLastName}
                onChange={(e) => {
                  setGiftedLastName(e.target.value)
                  validateGiftedLastName(e.target.value)
                }}
                style={isErrorGiftedLastName ? { borderColor: 'red' } : {}}
              />
            </Col>
            <Col span={window.innerWidth >= 992 ? 8 : 24} className="data-gift">
              <PhoneInput
                inputStyle={{
                  width: '100%',
                  height: '2vh',
                }}
                // onKeyUp={handleKeyPress}
                className="phoneInp"
                isValid={isValidGiftedPhone}
                country="cl"
                preferredCountries={['cl', 'br', 'us']}
                value={giftedPhone}
                onChange={(value, country, e, formattedValue) => {
                  if (value.length >= 11) {
                    setPhone(value)
                    validatePhone(e.target.value)
                  } else {
                    return null
                  }
                }}
                masks={{ cl: '(..) ... ....' }}
                autoFormat
                specialLabel=""
              />
            </Col>
            <Col
              span={window.innerWidth >= 992 ? 8 : 24}
              className="label-hr-gift"
            >
              <Input
                size="middle"
                // onKeyUp={handleKeyPress}
                error={isErrorGiftedEmail ? 'error' : null}
                placeholder="Correo eletrónico"
                variant="outlined"
                required
                value={giftedEmail}
                onChange={(e) => {
                  setGiftedEmail(e.target.value)

                  validateGiftedEmail(e.target.value)
                }}
                className="inputnumber"
                style={isErrorGiftedEmail ? { borderColor: 'red' } : {}}
              />
            </Col>
          </Row>
        </>
      )}
    </div>
  )
}

export default PersonalInfo
